import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
  Button,
  CardSubtitle,
  CardText,
} from "reactstrap";
import { Link } from "react-router-dom";

// --- Import Images ---
import planDirector from "../../assets/img/faces/11.png";
import dep0 from "../../assets/img/faces/dep0_0.jpg";
import dep1 from "../../assets/img/faces/dep1_0.jpg";
import dep2 from "../../assets/img/faces/dep2_0.png";
import dep3 from "../../assets/img/faces/dep3_0.png";
import dep1_3 from "../../assets/img/faces/dep1_3.png";
import dep1_4 from "../../assets/img/faces/dep1_4.png";
import dep1_5 from "../../assets/img/faces/louis.png";
import dep1_6 from "../../assets/img/faces/dep1_6-3.png";
import dep1_7 from "../../assets/img/faces/dep1_7.jpeg";
import dep2_3 from "../../assets/img/faces/dep2_3.png";
import dep2_4 from "../../assets/img/faces/dep2_4.png";
import dep2_5 from "../../assets/img/faces/dep2_5.png";
import dep2_6 from "../../assets/img/faces/dep2_6.png";
import dep2_7 from "../../assets/img/faces/pong.png";
import dep2_8 from "../../assets/img/faces/IMG_4551.jpeg";
import dep2_9 from "../../assets/img/faces/dep2_7.png";
import dep2_10 from "../../assets/img/faces/dep2_8.png";
import dep3_2 from "../../assets/img/faces/dep3_2.png";
import dep3_3 from "../../assets/img/faces/dep3_3.jpg";
import dep3_4 from "../../assets/img/faces/dep3_4.png";
import dep3_5 from "../../assets/img/faces/dep3_5.png";
import dep3_7 from "../../assets/img/faces/dep3_7.png";
import phone from "../../assets/img/faces/phone.png";
import S__61292581 from "../../assets/img/faces/S__61292581.png";

const cardStyle = {
  display: "block",
  transitionDuration: "0.3s",
};

// คอมโพเนนต์ย่อยสำหรับสร้าง Card เพื่อลดความซ้ำซ้อนของ Code
const ProfileCard = ({ img, name, subtitle, email, tel }) => (
  <Col md="3" className="d-flex align-items-stretch mb-4">
    <Card className="card-profile w-100">
      <div className="card-avatar">
        <a href="#pablo" onClick={(e) => e.preventDefault()}>
          <img alt="..." src={img} />
        </a>
      </div>
      <CardBody style={cardStyle} className="d-flex flex-column">
        <div className="author">
          <CardTitle tag="h5" style={{ minHeight: "3.5em" }}>{name}</CardTitle>
          <CardSubtitle tag="h6" className="mb-2 text-muted">
            {subtitle}
          </CardSubtitle>
        </div>
      </CardBody>
      <CardFooter className="text-center mt-auto">
        <CardText className="small text-uppercase">{email}</CardText>
        <CardText className="small">{tel}</CardText>
      </CardFooter>
    </Card>
  </Col>
);

function SpiningCard() {
  return (
    <>
      <div className="section section-navbars">
        {/* ส่วนผู้บริหารระดับสูง */}
        <Container>
          <Row className="justify-content-center">
            <Col md="4" className="d-flex align-items-stretch mb-4">
              <Card className="card-profile w-100">
                <div className="card-avatar">
                  <img alt="..." src={planDirector} />
                </div>
                <CardBody style={cardStyle}>
                  <div className="author">
                    <CardTitle tag="h5">นางสาวเสาวณีย์ คูพูลทรัพย์</CardTitle>
                    <CardSubtitle tag="h6" className="mb-2 text-muted">
                      ผู้อำนวยการกองแผนงาน
                    </CardSubtitle>
                  </div>
                </CardBody>
                <CardFooter className="text-center mt-auto">
                  <CardText className="small">KUPULSUB_S@SU.AC.TH</CardText>
                  <CardText className="small">โทรศัพท์ :0 2105 4686 ต่อ 100081</CardText>
                </CardFooter>
              </Card>
            </Col>
          </Row>

          {/* แถวหัวหน้างาน */}
          <Row className="d-flex flex-wrap">
            <ProfileCard img={dep0} name="นางจุฑารัตน์ แก้วโหมดตาด" subtitle="ผู้ช่วยผู้อำนวยการกอง" email="kaewmodetard_j@su.ac.th" tel="โทรศัพท์ :0 2105 4686 ต่อ 100082" />
            <ProfileCard img={dep1} name="นางสาวอริยา ทรงประไพ" subtitle="หัวหน้างานวิเคราะห์งบประมาณ" email="songprapai_a@su.ac.th" tel="โทรศัพท์ :0 2105 4686 ต่อ 100092" />
            <ProfileCard img={dep2} name="นางสาวกฤติญา จันทพันธ์" subtitle="หัวหน้างานยุทธศาสตร์และวิจัยสถาบัน" email="chantapun_s@su.ac.th" tel="โทรศัพท์ :0 2105 4686 ต่อ 100102" />
            <ProfileCard img={dep3_3} name={<>นางสาวณัฏฐภัค <br /> ทรัพย์สมบูรณ์</>} subtitle="รักษาการแทนหัวหน้างานวางแผนและพัฒนากายภาพ" email="supsomboon_n@su.ac.th" tel="โทรศัพท์ :0 2105 4686 ต่อ 100115" />
          </Row>
        </Container>

        {/* งานวิเคราะห์งบประมาณ */}
        <Container className="mt-5">
          <h4 className="title text-center">บุคลากร</h4>
          <Row><h5>งานวิเคราะห์งบประมาณ</h5></Row>
          <Row className="d-flex flex-wrap">
            <ProfileCard img={dep1} name="นางสาวอริยา ทรงประไพ" subtitle="หัวหน้างานวิเคราะห์งบประมาณ" email="songprapai_a@su.ac.th" tel="โทรศัพท์ :100092" />
            <ProfileCard img={dep1_3} name="นางอำนวย ช่วยพันธ์" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="chuaiphan_a@su.ac.th" tel="โทรศัพท์ :100093" />
            <ProfileCard img={dep1_4} name="นางสาวพชรมณ เลาหล่าย" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="laolay_p@su.ac.th" tel="โทรศัพท์ :200020" />
            <ProfileCard img={dep1_5} name="นางสาวณัฐฐา ถิรโสภี" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="theerasopee_n@su.ac.th" tel="โทรศัพท์ :100093" />
            <ProfileCard img={dep2_8} name="นายอิทธิพัทธ์ คล้ายปาน" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="KLAYPARN_I@su.ac.th" tel="โทรศัพท์ :100094" />
            <ProfileCard img={dep1_7} name="นางสาวภัทราพร  เตชาภินันท์" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="techapinant_p@su.ac.th" tel="โทรศัพท์ :100095" />
            <ProfileCard img={dep1_6} name="นายศิลา สังข์จุ้ย" subtitle="นักคอมพิวเตอร์ชำนาญการ" email="sungjuic_w@su.ac.th" tel="โทรศัพท์ :100095" />
          </Row>
        </Container>

        {/* งานยุทธศาสตร์และวิจัยสถาบัน */}
        <Container className="mt-5">
          <Row><h5>งานยุทธศาสตร์และวิจัยสถาบัน</h5></Row>
          <Row className="d-flex flex-wrap">
            <ProfileCard img={dep2} name="นางสาวกฤติญา จันทพันธ์" subtitle="หัวหน้างานยุทธศาสตร์และวิจัยสถาบัน" email="chantapun_s@su.ac.th" tel="โทรศัพท์ :100102" />
            <ProfileCard img={dep2_3} name={<>นางสาวเบญจมาศ <br /> ขุนประเสริฐ</>} subtitle="นักวิชาการอุดมศึกษาชำนาญการ" email="khunprasert_b@su.ac.th" tel="โทรศัพท์ :100104" />
            <ProfileCard img={dep2_4} name="นายฉัตรชัย ศิริสมบูรณ์ลาภ" subtitle="นักวิชาการอุดมศึกษาชำนาญการ" email="sirisomboonlarp_c@su.ac.th" tel="โทรศัพท์ :100019" />
            <ProfileCard img={dep2_6} name="นางสาวอริษา พิภพศิริรัตน์" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="pipobsirirat_a@su.ac.th" tel="โทรศัพท์ :100103" />
            <ProfileCard img={dep2_7} name="นายกิติพงษ์ เท้งสี" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="thangsi_k@su.ac.th" tel="โทรศัพท์ :100105" />
            <ProfileCard img={dep2_5} name="นางสาวพชรพร อิ่มชื่น" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="imchuen_p@su.ac.th" tel="โทรศัพท์ :100105" />
            <ProfileCard img={dep2_9} name="นายธเนศ รัศมี" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="rasame_t@su.ac.th" tel="โทรศัพท์ :100103" />
            <ProfileCard img={dep2_10} name="นายปุริม เลี่ยนศิริ" subtitle="นักวิชาการอุดมศึกษาปฏิบัติการ" email="liansiri_p@su.ac.th" tel="โทรศัพท์ :100104" />
          </Row>
        </Container>

        {/* งานวางแผนและพัฒนากายภาพ */}
        <Container className="mt-5">
          <Row><h5>งานวางแผนและพัฒนากายภาพ</h5></Row>
          <Row className="d-flex flex-wrap">
            <ProfileCard img={dep3_3} name="นางสาวณัฏฐภัค ทรัพย์สมบูรณ์" subtitle="รักษาการแทนหัวหน้างานวางแผนและพัฒนากายภาพ" email="supsomboon_n@su.ac.th" tel="โทรศัพท์ :100115" />
            <ProfileCard img={dep3} name="นายนิรันดร์ แสงพุ่ม" subtitle="วิศวกรไฟฟ้าชำนาญการ" email="sangphum_n@su.ac.th" tel="โทรศัพท์ :100112" />
            <ProfileCard img={dep3_2} name="นางสาวสุชิน สิงหเดช" subtitle="ช่างเขียนแบบชำนาญงาน" email="singhaded_s@su.ac.th" tel="โทรศัพท์ :200020" />
            <ProfileCard img={dep3_4} name="นายจารึก จ่ากลาง" subtitle="วิศวกรปฏิบัติการ" email="jaklang_j@su.ac.th" tel="โทรศัพท์ :200020" />
            <ProfileCard img={dep3_5} name="นายนาถวุฒิ ศรีเกตุ" subtitle="วิศวกรปฏิบัติการ" email="srikate_n@su.ac.th" tel="โทรศัพท์ :100113" />
            <ProfileCard img={dep3_7} name="นายณรงค์เดช สุนทรกุล ณ ชลบุรี" subtitle="ช่างเขียนแบบปฏิบัติการ" email="soontrongul_n@su.ac.th" tel="โทรศัพท์ :100115" />
            <ProfileCard img={phone} name="นาย ภูริณัฐ ศรีวิบูลย์" subtitle="วิศวกรปฏิบัติการ" email="SRIWIBOON_P@SU.AC.TH" tel="โทรศัพท์ :100115" />
            <ProfileCard img={S__61292581} name="นางสาวจุไรวรรณ  เบญจธัญญลักษณ์" subtitle="สถาปนิกปฏิบัติการ" email="BANJATUNYALUCK_J@SU.AC.TH" tel="โทรศัพท์ :100115" />

          </Row>
        </Container>

        <Container className="mt-5">
          <Row className="text-center">
            <Col>
              <Link to="/">
                <Button outline color="danger" size="sm">กลับหน้าหลัก</Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default SpiningCard;